module.exports = __webpack_public_path__ + "static/media/bounding_boxes.ef24d840.png";